import React from 'react';
import { useIsEmbeddedMobile } from '../../../../../../../_hooks/useIsEmbeddedMobile';
import { useUnrealizedGainLoss } from '../../../../../../hooks/useUnrealizedGainLoss';
import { DesktopTotals } from './components/DesktopTotals/DesktopTotals';
import { MobileTotals } from './components/MobileTotals/MobileTotals';
import { TotalsLoading } from './Totals.loading';

interface Props {
  title: string;
}

export const Totals = ({ title }: Props) => {
  const isEmbeddedMobile = useIsEmbeddedMobile();

  const { isFetching, data } = useUnrealizedGainLoss();

  if (isFetching) {
    return <TotalsLoading isEmbeddedMobile={isEmbeddedMobile} title={title} />;
  }

  if (!data) {
    return null;
  }

  const unrealizedGainLossTotals = data?.totals;

  if (
    !unrealizedGainLossTotals ||
    unrealizedGainLossTotals.shortTerm == null ||
    unrealizedGainLossTotals.longTerm == null ||
    unrealizedGainLossTotals.total == null
  ) {
    return null;
  }

  if (isEmbeddedMobile) {
    return <MobileTotals {...unrealizedGainLossTotals} title={title} />;
  }

  return <DesktopTotals {...unrealizedGainLossTotals} title={title} />;
};
